module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"close_today":"今日不再顯示"}}')
  delete Component.options._Ctor
}
